import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Badge from 'react-bootstrap/lib/Badge';
import classNames from 'classnames';

import Flex from '../../../../researcher/blocks/flex/flex';
import FlexItem from '../../../../researcher/blocks/flex/flex-item';
import Media from '../../../../researcher/blocks/media';
import LargeNav from './nav--large/nav';
import SmallNav from './nav--small/nav--small';
import ParticipantLogo from './logo/participant-logo';
import {
  SURVEYS__SHAPE_ITEM,
  SURVEY_CLIENT__SHAPE_ITEM,
} from '../../../../researcher/redux/constants';

import * as css from './participant-header.scss';
import { useBranding } from '../../../redux/selectors';

const ParticipantHeader = ({ progress, surveyClient, survey, ...props }) => {
  const { logo, enabled } = useBranding();
  const hasLogo = !!logo || !enabled;
  if (survey && survey.hideProgress) return null;
  return (
    <header>
      <Media medium large>
        <table className={css.headerLarge} style={{ verticalAlign: 'middle' }}>
          <tbody>
            <tr>
              {hasLogo && (
                <td className={css.logo}>
                  <ParticipantLogo />
                </td>
              )}
              <td>
                <LargeNav {...props} surveyClient={surveyClient} />
              </td>
              <td width="100%" className={css.rest} />
            </tr>
          </tbody>
        </table>
      </Media>
      <Media phone tablet>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          className={classNames(css.headerSmall, {
            [css.headerFixed]: surveyClient.showProgress,
          })}
        >
          {hasLogo && <ParticipantLogo small size={32} />}
          <Fragment>
            <FlexItem flexGrow={1}>
              <div>
                <SmallNav {...props} progress={progress} surveyClient={surveyClient} />
              </div>
            </FlexItem>
            <div className={css.badge}>
              <Badge>{progress}%</Badge>
            </div>
          </Fragment>
        </Flex>
      </Media>
    </header>
  );
};

ParticipantHeader.propTypes = {
  progress: PropTypes.number.isRequired,
  survey: SURVEYS__SHAPE_ITEM,
  surveyClient: SURVEY_CLIENT__SHAPE_ITEM.isRequired,
};

ParticipantHeader.defaultProps = {
  survey: undefined,
};

export default ParticipantHeader;
